'use client';

import { useEffect, useRef, useCallback } from 'react';

/**
 * @typedef {{ x: number, y: number, char: string, color: string, bgColor?: string }} CellData
 * @typedef {{ duration: number, cells: CellData[] }} Frame
 */

/**
 * @typedef {Object} AsciiMotionComponentProps
 * @property {boolean} [showControls]
 * @property {boolean} [autoPlay]
 * @property {(api: { play: () => void; pause: () => void; togglePlay: () => void; restart: () => void; }) => void} [onReady]
 */

const FRAMES = [
  {
    "duration": 100,
    "cells": [
      {
        "x": 0,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 1,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 2,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 10,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 11,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 12,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 8,
        "char": "L",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 8,
        "char": "O",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 8,
        "char": "A",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 8,
        "char": "D",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 8,
        "char": "I",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 8,
        "char": "N",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 8,
        "char": "G",
        "color": "#000000"
      }
    ]
  },
  {
    "duration": 100,
    "cells": [
      {
        "x": 2,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 10,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 0,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 1,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 2,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 10,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 11,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 12,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 8,
        "char": "L",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 8,
        "char": "O",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 8,
        "char": "A",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 8,
        "char": "D",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 8,
        "char": "I",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 8,
        "char": "N",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 8,
        "char": "G",
        "color": "#000000"
      }
    ]
  },
  {
    "duration": 100,
    "cells": [
      {
        "x": 3,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 2,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 10,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 0,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 1,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 2,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 10,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 11,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 12,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 8,
        "char": "L",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 8,
        "char": "O",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 8,
        "char": "A",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 8,
        "char": "D",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 8,
        "char": "I",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 8,
        "char": "N",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 8,
        "char": "G",
        "color": "#000000"
      }
    ]
  },
  {
    "duration": 100,
    "cells": [
      {
        "x": 4,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 2,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 10,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 0,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 1,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 2,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 10,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 11,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 12,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 8,
        "char": "L",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 8,
        "char": "O",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 8,
        "char": "A",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 8,
        "char": "D",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 8,
        "char": "I",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 8,
        "char": "N",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 8,
        "char": "G",
        "color": "#000000"
      }
    ]
  },
  {
    "duration": 100,
    "cells": [
      {
        "x": 5,
        "y": 2,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 2,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 2,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 2,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 10,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 0,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 1,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 2,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 10,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 11,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 12,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 8,
        "char": "L",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 8,
        "char": "O",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 8,
        "char": "A",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 8,
        "char": "D",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 8,
        "char": "I",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 8,
        "char": "N",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 8,
        "char": "G",
        "color": "#000000"
      }
    ]
  },
  {
    "duration": 100,
    "cells": [
      {
        "x": 6,
        "y": 1,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 2,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 2,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 2,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 2,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 10,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 0,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 1,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 2,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 10,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 11,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 12,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 8,
        "char": "L",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 8,
        "char": "O",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 8,
        "char": "A",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 8,
        "char": "D",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 8,
        "char": "I",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 8,
        "char": "N",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 8,
        "char": "G",
        "color": "#000000"
      }
    ]
  },
  {
    "duration": 100,
    "cells": [
      {
        "x": 6,
        "y": 1,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 1,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 2,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 2,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 2,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 2,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 10,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 0,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 1,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 2,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 10,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 11,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 12,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 8,
        "char": "L",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 8,
        "char": "O",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 8,
        "char": "A",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 8,
        "char": "D",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 8,
        "char": "I",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 8,
        "char": "N",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 8,
        "char": "G",
        "color": "#000000"
      }
    ]
  },
  {
    "duration": 100,
    "cells": [
      {
        "x": 6,
        "y": 1,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 1,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 1,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 1,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 2,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 2,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 2,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 2,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 10,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 0,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 1,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 2,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 10,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 11,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 12,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 8,
        "char": "L",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 8,
        "char": "O",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 8,
        "char": "A",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 8,
        "char": "D",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 8,
        "char": "I",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 8,
        "char": "N",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 8,
        "char": "G",
        "color": "#000000"
      }
    ]
  },
  {
    "duration": 100,
    "cells": [
      {
        "x": 6,
        "y": 1,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 1,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 1,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 1,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 2,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 2,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 2,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 2,
        "char": "1",
        "color": "#FFFFFF"
      },
      {
        "x": 4,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 2,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 0,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 1,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 2,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 10,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 11,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 12,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 8,
        "char": "L",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 8,
        "char": "O",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 8,
        "char": "A",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 8,
        "char": "D",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 8,
        "char": "I",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 8,
        "char": "N",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 8,
        "char": "G",
        "color": "#000000"
      }
    ]
  },
  {
    "duration": 100,
    "cells": [
      {
        "x": 6,
        "y": 1,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 1,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 1,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 1,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 2,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 2,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 2,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 2,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 0,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 1,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 2,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 10,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 11,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 12,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 8,
        "char": "L",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 8,
        "char": "O",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 8,
        "char": "A",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 8,
        "char": "D",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 8,
        "char": "I",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 8,
        "char": "N",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 8,
        "char": "G",
        "color": "#000000"
      }
    ]
  },
  {
    "duration": 100,
    "cells": [
      {
        "x": 6,
        "y": 1,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 1,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 1,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 1,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 2,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 2,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 2,
        "char": "1",
        "color": "#FFFFFF"
      },
      {
        "x": 4,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 2,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 0,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 1,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 2,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 10,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 11,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 12,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 8,
        "char": "L",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 8,
        "char": "O",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 8,
        "char": "A",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 8,
        "char": "D",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 8,
        "char": "I",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 8,
        "char": "N",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 8,
        "char": "G",
        "color": "#000000"
      }
    ]
  },
  {
    "duration": 100,
    "cells": [
      {
        "x": 6,
        "y": 1,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 1,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 1,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 2,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 2,
        "char": "1",
        "color": "#FFFFFF"
      },
      {
        "x": 8,
        "y": 2,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 2,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 2,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 0,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 1,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 2,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 10,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 11,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 12,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 8,
        "char": "L",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 8,
        "char": "O",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 8,
        "char": "A",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 8,
        "char": "D",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 8,
        "char": "I",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 8,
        "char": "N",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 8,
        "char": "G",
        "color": "#000000"
      }
    ]
  },
  {
    "duration": 100,
    "cells": [
      {
        "x": 7,
        "y": 1,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 2,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 2,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 2,
        "char": "1",
        "color": "#FFFFFF"
      },
      {
        "x": 8,
        "y": 2,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 2,
        "char": "1",
        "color": "#FFFFFF"
      },
      {
        "x": 4,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 10,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 2,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 0,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 1,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 2,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 10,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 11,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 12,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 8,
        "char": "L",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 8,
        "char": "O",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 8,
        "char": "A",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 8,
        "char": "D",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 8,
        "char": "I",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 8,
        "char": "N",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 8,
        "char": "G",
        "color": "#000000"
      }
    ]
  },
  {
    "duration": 100,
    "cells": [
      {
        "x": 6,
        "y": 2,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 2,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 2,
        "char": "1",
        "color": "#FFFFFF"
      },
      {
        "x": 4,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 10,
        "y": 3,
        "char": "1",
        "color": "#FFFFFF"
      },
      {
        "x": 3,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 10,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 2,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 0,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 1,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 2,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 10,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 11,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 12,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 8,
        "char": "L",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 8,
        "char": "O",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 8,
        "char": "A",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 8,
        "char": "D",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 8,
        "char": "I",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 8,
        "char": "N",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 8,
        "char": "G",
        "color": "#000000"
      }
    ]
  },
  {
    "duration": 100,
    "cells": [
      {
        "x": 5,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 3,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 2,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 10,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 0,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 1,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 2,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 10,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 11,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 12,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 8,
        "char": "L",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 8,
        "char": "O",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 8,
        "char": "A",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 8,
        "char": "D",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 8,
        "char": "I",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 8,
        "char": "N",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 8,
        "char": "G",
        "color": "#000000"
      }
    ]
  },
  {
    "duration": 100,
    "cells": [
      {
        "x": 4,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 4,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 2,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 10,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 0,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 1,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 2,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 10,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 11,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 12,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 8,
        "char": "L",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 8,
        "char": "O",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 8,
        "char": "A",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 8,
        "char": "D",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 8,
        "char": "I",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 8,
        "char": "N",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 8,
        "char": "G",
        "color": "#000000"
      }
    ]
  },
  {
    "duration": 100,
    "cells": [
      {
        "x": 2,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 10,
        "y": 5,
        "char": "1",
        "color": "#000000"
      },
      {
        "x": 0,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 1,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 2,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 10,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 11,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 12,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 8,
        "char": "L",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 8,
        "char": "O",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 8,
        "char": "A",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 8,
        "char": "D",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 8,
        "char": "I",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 8,
        "char": "N",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 8,
        "char": "G",
        "color": "#000000"
      }
    ]
  },
  {
    "duration": 100,
    "cells": [
      {
        "x": 0,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 1,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 2,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 10,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 11,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 12,
        "y": 6,
        "char": "0",
        "color": "#000000"
      },
      {
        "x": 3,
        "y": 8,
        "char": "L",
        "color": "#000000"
      },
      {
        "x": 4,
        "y": 8,
        "char": "O",
        "color": "#000000"
      },
      {
        "x": 5,
        "y": 8,
        "char": "A",
        "color": "#000000"
      },
      {
        "x": 6,
        "y": 8,
        "char": "D",
        "color": "#000000"
      },
      {
        "x": 7,
        "y": 8,
        "char": "I",
        "color": "#000000"
      },
      {
        "x": 8,
        "y": 8,
        "char": "N",
        "color": "#000000"
      },
      {
        "x": 9,
        "y": 8,
        "char": "G",
        "color": "#000000"
      }
    ]
  }
];

const CANVAS_WIDTH = 140.4;
const CANVAS_HEIGHT = 180;
const CELL_WIDTH = 10.8;
const CELL_HEIGHT = 18;
const FONT_SIZE = 18;
const FONT_FAMILY = "SF Mono, Monaco, Cascadia Code, Consolas, JetBrains Mono, Fira Code, Monaspace Neon, Geist Mono, Courier New, monospace";
const BACKGROUND_COLOR = null;

const AsciiMotionAnimation = (props = {}) => {
  const { showControls = true, autoPlay = true, onReady } = props;
  const initialAutoPlay = autoPlay !== false;
  const canvasRef = useRef(null);
  const animationFrameRef = useRef(null);
  const frameIndexRef = useRef(0);
  const frameElapsedRef = useRef(0);
  const lastTimestampRef = useRef(0);
  const restartRef = useRef(() => {});
  const isPlayingRef = useRef(initialAutoPlay);
  const updatePlayingState = useCallback((value) => {
    isPlayingRef.current = value;
  }, []);
  const play = useCallback(() => {
    updatePlayingState(true);
  }, [updatePlayingState]);
  const pause = useCallback(() => {
    updatePlayingState(false);
  }, [updatePlayingState]);
  const togglePlay = useCallback(() => {
    updatePlayingState(!isPlayingRef.current);
  }, [updatePlayingState]);
  const restart = useCallback(() => {
    if (restartRef.current) {
      restartRef.current();
    }
  }, []);

  useEffect(() => {
    if (isPlayingRef.current !== initialAutoPlay) {
      updatePlayingState(initialAutoPlay);
    }
  }, [initialAutoPlay, updatePlayingState]);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) {
      return;
    }

    const context = canvas.getContext('2d');
    if (!context) {
      return;
    }

    const devicePixelRatio = window.devicePixelRatio || 1;
    canvas.width = CANVAS_WIDTH * devicePixelRatio;
    canvas.height = CANVAS_HEIGHT * devicePixelRatio;
    canvas.style.width = CANVAS_WIDTH + 'px';
    canvas.style.height = CANVAS_HEIGHT + 'px';
    context.resetTransform();
    context.scale(devicePixelRatio, devicePixelRatio);
    context.textAlign = 'center';
    context.textBaseline = 'middle';
    context.font = FONT_SIZE + 'px ' + FONT_FAMILY;
    context.imageSmoothingEnabled = false;

    frameIndexRef.current = 0;
    frameElapsedRef.current = 0;
    lastTimestampRef.current = 0;

    const drawFrame = (index) => {
      const frame = FRAMES[index];

      if (BACKGROUND_COLOR) {
        context.fillStyle = BACKGROUND_COLOR;
        context.fillRect(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT);
      } else {
        context.clearRect(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT);
      }

      if (!frame) {
        return;
      }

      for (const cell of frame.cells) {
        if (cell.bgColor) {
          context.fillStyle = cell.bgColor;
          context.fillRect(cell.x * CELL_WIDTH, cell.y * CELL_HEIGHT, CELL_WIDTH, CELL_HEIGHT);
        }

        context.fillStyle = cell.color || '#ffffff';
        context.fillText(
          cell.char,
          cell.x * CELL_WIDTH + CELL_WIDTH / 2,
          cell.y * CELL_HEIGHT + CELL_HEIGHT / 2
        );
      }
    };

    drawFrame(frameIndexRef.current);

    if (FRAMES.length === 0) {
      restartRef.current = () => {
        drawFrame(0);
      };
      return;
    }

    const step = (timestamp) => {
      if (FRAMES.length === 0) {
        return;
      }

      if (lastTimestampRef.current === 0) {
        lastTimestampRef.current = timestamp;
      }

      const delta = timestamp - lastTimestampRef.current;
      lastTimestampRef.current = timestamp;

      if (isPlayingRef.current) {
        frameElapsedRef.current += delta;

        let nextIndex = frameIndexRef.current;
        let remaining = frameElapsedRef.current;
        let duration = FRAMES[nextIndex]?.duration ?? 16;

        while (remaining >= duration && FRAMES.length > 0) {
          remaining -= duration;
          nextIndex = (nextIndex + 1) % FRAMES.length;
          duration = FRAMES[nextIndex]?.duration ?? duration;
        }

        frameElapsedRef.current = remaining;

        if (nextIndex !== frameIndexRef.current) {
          frameIndexRef.current = nextIndex;
          drawFrame(nextIndex);
        } else {
          drawFrame(frameIndexRef.current);
        }
      } else {
        drawFrame(frameIndexRef.current);
      }

      animationFrameRef.current = window.requestAnimationFrame(step);
    };

    animationFrameRef.current = window.requestAnimationFrame(step);

    restartRef.current = () => {
      frameIndexRef.current = 0;
      frameElapsedRef.current = 0;
      lastTimestampRef.current = 0;
      drawFrame(0);
    };

    return () => {
      if (animationFrameRef.current !== null) {
        window.cancelAnimationFrame(animationFrameRef.current);
        animationFrameRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (typeof onReady === "function") {
      onReady({
        play,
        pause,
        togglePlay,
        restart,
      });
    }
  }, [onReady, play, pause, togglePlay, restart]);
  return (
    <div
      style={{
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      <canvas
        ref={canvasRef}
        width={CANVAS_WIDTH}
        height={CANVAS_HEIGHT}
        style={{
          width: CANVAS_WIDTH + 'px',
          height: CANVAS_HEIGHT + 'px',
          backgroundColor: BACKGROUND_COLOR || 'transparent',
          imageRendering: 'pixelated'
        }}
      />
    </div>
  );
};

export default AsciiMotionAnimation;
